// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"994b363a","250":"674d503d","719":"1c753d9a","828":"979e1f8b"}[chunkId] + ".chunk.css";
};